import { AppState } from "@Store/index";

/** Raw, unnarrowed. Requirement 1.5 admits `null` and non-object values here. */
export const selectNeighbourhoodPayload = ({ propertyPageData }: AppState): unknown =>
  propertyPageData?.data?.region?.neighbourhood;

/** Raw, unnarrowed. Requirement 4.4 admits absent and non-array values here. */
export const selectNearbyDistances = ({ propertyPageData }: AppState): unknown =>
  propertyPageData?.data?.nearby_distances;

/** Country short code, e.g. "US", "UK". */
export const selectCountryShortCode = ({ propertyPageData }: AppState): string | undefined =>
  propertyPageData?.data?.location?.country?.short_name;

/** Backs the client-mounted Loading_Skeleton gate. Consumption is specified later. */
export const selectPropertyReadyStatus = ({ propertyPageData }: AppState): string =>
  propertyPageData?.readyStatus ?? "";

const IN_FLIGHT: ReadonlySet<string> = new Set(["invalid", "request"]);

export const isPropertyFetchInFlight = (readyStatus: string): boolean => IN_FLIGHT.has(readyStatus);
